import _ from "lodash";
import { defineComponent, ref } from "vue";
import { Search } from "@element-plus/icons-vue";
export default defineComponent({
  name: "Search",
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var isSearch = ref(false);
    var isSuggest = ref(false);
    var showPanel = ref(); //输入框绑定值

    var inputValue = ref(""); //用户在文档任何地方点击时触发

    document.addEventListener("click", function (e) {
      if (showPanel.value) {
        //查找$refs.showPanel 是否包含 触发事件的标签，返回boolean e.target表示触发事件的标签
        var isSelf = showPanel.value.contains(e.target);

        if (!isSelf) {
          //若不存在
          isSearch.value = false; //则隐藏搜索div

          isSuggest.value = false; //则隐藏搜索建议
        }
      }
    });
    /* 输入框获取焦点 */

    var getFocus = function getFocus() {
      if (inputValue.value == "") {
        isSearch.value = true;
        isSuggest.value = false;
      } else {
        isSearch.value = false;
        isSuggest.value = true;
      }
    }; //输入框值改变时事件


    var handleChangeValue = _.debounce(function () {
      emit("handleChangeValue", inputValue.value);
      getFocus();
    }, 200);

    return {
      isSearch: isSearch,
      isSuggest: isSuggest,
      showPanel: showPanel,
      inputValue: inputValue,
      getFocus: getFocus,
      handleChangeValue: handleChangeValue,
      Search: Search
    };
  },
  components: {}
});